export { default } from './SmartGoalPopup';
